import { ECustomerEvents, ESessionEvents, IAnalyticsCustomerData, IAnalyticsSessionData } from 'data/analytics';
import { getLinks, IPublicSession } from 'state/session';
import { UAParser } from 'ua-parser-js';
import { sendMetric } from 'utils/network/postAnalytics';
import { user } from 'utils/auth/user';
import { IAnalyticsDto } from 'state/analytics';
import { t } from '@lingui/core/macro';

export async function sendCustomerAnalyticsEvent(
  action: ECustomerEvents,
  session: IPublicSession,
  analyticsData?: IAnalyticsDto
) {
  const { browser, device, os } = UAParser(navigator.userAgent);
  const data: IAnalyticsCustomerData = {
    sessionId: session.id!,
    mmToken: session.aveSessionId!,
    voipUsed: analyticsData?.voipUsed ?? false,
    action,
    deviceType: device.type ?? '',
    deviceBrand: device.vendor ?? '',
    browserName: browser.name ?? '',
    browserVersion: browser.version ?? '',
    osName: os.name ?? '',
    screenWidth: window.innerWidth.toString(),
    screenHeight: window.innerHeight.toString(),
    timestamp: String(Date.now()),
  };
  await sendMetric<IAnalyticsCustomerData>('customer', data);
}

export async function sendSessionAnalyticsEvent(
  type: ESessionEvents,
  session: IPublicSession,
  sendBeacon?: boolean,
  analyticsData?: IAnalyticsDto
) {
  if (!analyticsData) {
    // Lazy load to avoid circular dependency when calling from the session state
    const { analyticsState } = await import('state/analytics');
    analyticsData = analyticsState().get() as IAnalyticsDto;
  }

  const dealerKvps = user.dealerId;
  const { customerStreamUrl } = getLinks();
  const data: IAnalyticsSessionData = {
    sessionId: session.id!,
    status: type,
    virtualExhibitionType: session.sharingType ?? '',
    dealerIdMat: user.dealerId ?? '',
    dealerIdKvps: dealerKvps,
    prString: session.prString ?? '',
    country: session.market!,
    voipUsed: analyticsData?.voipUsed ?? false,
    timezone: session.locale!,
    mmToken: session.aveSessionId!,
    url: customerStreamUrl,
    carSelectionMethod: session.carSelectionMethod ?? '',
    // if the car is configured via DCC/SCC, we set a static value as car model instead of the translated placeholder. This eases processing on team analytics side.
    carModel: session.carDisplayName
      ? session.carDisplayName === t`Configured car`
        ? 'Configured car'
        : session.carDisplayName
      : '',
    dgaGeneratedAt: analyticsData?.dgaGeneratedAt ?? '',
    dealerToolUsed: analyticsData?.dealerToolUsed ?? '',
    hasTimedOut: session.hasTimedOut ?? false,
    tenant: session.partnerToken!,
    experience2DUsed: analyticsData?.experience2DUsed ?? false,
    experience3DUsed: analyticsData?.experience3DUsed ?? false,
    comparisonUsed: analyticsData?.comparisonUsed ?? false,
    timestamp: String(Date.now()),
  };
  await sendMetric<IAnalyticsSessionData>('session', data, sendBeacon);
}
